import { ArrowUpRight, Heart, Sparkles } from "lucide-react";
import { ETSY_SHOP, slug } from "../data/site";

export const ProductCard = ({ item, setId }) => {
  const live = Boolean(item.url);

  return (
    <a
      href={item.url || ETSY_SHOP}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`product-card-${setId}-${slug(item.key || item.name)}`}
      className="group relative flex h-full flex-col justify-between overflow-hidden border border-navy/25 bg-cream transition-transform duration-500 hover:-translate-y-2 hover:shadow-[0_30px_60px_-25px_rgba(27,42,74,0.4)]"
    >
      {item.image ? (
        <div className="aspect-square w-full overflow-hidden border-b border-navy/15 bg-blush">
          <img
            src={item.image}
            alt={item.name}
            loading="lazy"
            data-testid={`product-image-${setId}-${slug(item.name)}`}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
      ) : null}

      <div className="flex flex-1 flex-col justify-between p-6 md:p-8">
        <div>
          <div className="flex items-center justify-between gap-3">
            <span className="font-caveat text-xl font-semibold text-navy/70">
              Dream Freely
              <Heart className="mb-1 ml-1 inline-block h-3 w-3 fill-mustard text-mustard" />
            </span>
            {item.personalization ? (
              <span className="flex items-center gap-1 text-[9px] uppercase tracking-[0.2em] text-navy/40">
                <Sparkles className="h-3 w-3" /> Personalizable
              </span>
            ) : null}
          </div>
          <p className={`font-playfair text-base italic leading-snug text-mustard ${item.image ? "mt-6" : "mt-10 md:mt-14"}`}>
            {item.phrase || item.tagline}
          </p>
          <h4 className="mt-2 font-playfair text-2xl leading-tight tracking-tight text-navy md:text-3xl">{item.name}</h4>
        </div>
        <div className="mt-10 flex items-center justify-between gap-3 border-t border-navy/15 pt-5">
          {live && item.liveState === "soldout" ? (
            <span
              data-testid={`sold-out-${setId}-${slug(item.name)}`}
              className="rounded-full border border-rose bg-rose/25 px-4 py-1.5 text-[10px] font-medium uppercase tracking-[0.2em] text-navy"
            >
              Sold Out
            </span>
          ) : live ? (
            <span className="flex flex-wrap items-center gap-3">
              <span className="rounded-full bg-navy px-4 py-1.5 text-[10px] font-medium uppercase tracking-[0.2em] text-cream">
                Shop on Etsy
              </span>
              {item.livePrice ? (
                <span data-testid={`product-price-${setId}-${slug(item.name)}`} className="font-playfair text-lg italic text-navy/80">
                  {item.livePrice}
                </span>
              ) : null}
            </span>
          ) : (
            <span
              data-testid={`coming-soon-${setId}-${slug(item.name)}`}
              className="rounded-full border border-navy/40 px-4 py-1.5 text-[10px] font-medium uppercase tracking-[0.2em] text-navy/70"
            >
              Coming Soon
            </span>
          )}
          <ArrowUpRight className="h-5 w-5 shrink-0 text-navy/30 opacity-0 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-navy group-hover:opacity-100" />
        </div>
      </div>
    </a>
  );
};
